import './App.css';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3';
import { PublicClientApplication } from '@azure/msal-browser';
import { MsalProvider, useIsAuthenticated } from '@azure/msal-react';
import { BrowserRouter } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import AppWrapper from './Views/Login/AppWrapper';
import { Router } from './Routing/Router';

export const msalConfig = {
  auth: {
    clientId: process.env.REACT_APP_AZURE_CLIENT_ID || 'default-client-id',
    authority: process.env.REACT_APP_AZURE_AUTHORITY || 'default-authority',
    redirectUri: process.env.REACT_APP_REDIRECT_URI || window.location.origin,
  },
  cache: {
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: true,
  },
};

export const msalInstance = new PublicClientApplication(msalConfig);

const AppContent = () => {
  const isAuthenticated = useIsAuthenticated();

  if (isAuthenticated) {
    return <Router />;
  } else {
    return <AppWrapper />;
  }
};

function App() {
  const queryClient = new QueryClient();

  return (
    <MsalProvider instance={msalInstance}>
      <QueryClientProvider client={queryClient}>
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <BrowserRouter>
            <AppContent />
            <Toaster />
          </BrowserRouter>
        </LocalizationProvider>
      </QueryClientProvider>
    </MsalProvider>
  );
}

export default App;
